import React from 'react';
import { Maximize2 } from 'lucide-react';
import PlantAgeHistogram from '../../../../Charts/PlantAgeHistogram';
import PlantSizeHistogram from '../../../../Charts/PlantSizeHistogram';

const ExistingStockCharts = ({ existingStockData, ChartCard }) => {
  const expandIcon = <Maximize2 className="h-5 w-5" />;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-4 md:mb-6">
      <ChartCard
        title="Plant Age Distribution"
        subtitle="Distribution of power plants by age and fuel type"
        icon={expandIcon}
        showHeader={false}
      >
        <PlantAgeHistogram data={existingStockData} />
      </ChartCard>

      <ChartCard
        title="Plant Size Distribution"
        subtitle="Distribution of power plants by capacity and fuel type"
        icon={expandIcon}
        showHeader={false}
      >
        <PlantSizeHistogram data={existingStockData} />
      </ChartCard>
    </div>
  );
};

export default ExistingStockCharts;
